<template>
  <div>
    <slot name="overview-tags" :is-raw="isRawDataCollection">
      <span
        v-if="isRawDataCollection"
        class="tag is-info has-text-weight-bold mx-2"
      >
        Raw
      </span>
    </slot>
    <slot name="collection-header" :has-datasets="datasetsCount > 0">
      <div
        v-if="dimensionsInfo.length > 0"
        class="is-flex is-align-items-baseline has-text-weight-bold pb-3"
      >
        <span class="tag is-success is-light">
          <span class="icon is-small pl-2 mr-2">
            <i class="fa-regular fa-copy fa-sm" />
          </span>
          {{ datasetsCount }}
          {{ pluralize('dataset', datasetsCount) }}
        </span>
        <span class="px-1">:</span>
        <ul class="is-flex">
          <li
            v-for="({ id, value, filesCount }, index) in dimensionsInfo"
            :key="`tag-${value}${index}`"
            class="is-flex is-align-items-center py-0"
          >
            <span class="tag is-info is-light has-text-weight-bold mr-2">
              <span class="icon is-small pr-1 pl-1">
                <i class="fa-regular fa-file fa-sm" />
              </span>
              <span v-if="id && value" class="pl-1">
                {{ value }}
              </span>
            </span>
            <span class="is-size-7">(x {{ filesCount }})</span>
          </li>
        </ul>
      </div>
    </slot>
    <slot
      name="collection-details"
      :datasets-count="datasetsCount"
      :has-datasets="datasetsCount > 0"
      :dataset-list="datasetsList"
      :dimensions-info="dimensionsInfo"
      :dimensions-names="dimensionsValues"
      :remove-collection-datasets="removeCollectionDatasets"
    >
      <ul>
        <li>
          {{ datasetsCount }}
          {{ pluralize('dataset', datasetsCount) }}:
        </li>
        <li v-for="(dimInfo, index) in dimensionsInfo" :key="index">
          Dimension {{ index + 1 }} : {{ dimInfo }}, name:
          {{ dimensionsValues[index] || 'null' }}
        </li>
        <li>
          <ul>
            <li v-for="({ name, files }, index) in datasetsList" :key="index">
              {{ name }}:
              <span class="is-size-7">(x {{ files.length }})</span>
            </li>
          </ul>
        </li>
      </ul>
    </slot>
  </div>
</template>

<script>
import pluralize from 'pluralize'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Collection',
  props: {
    collectionId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('dataloader/collections', ['collections']),
    ...mapGetters('dataloader/collections', ['getCollectionDatasetsList']),
    collection() {
      return this.collections[this.collectionId]
    },
    isRawDataCollection() {
      return this.collections.isRawData === true
    },
    dimensionsValues() {
      const dimNames = this.collection?.dimensionsValues || []
      return this.isRawDataCollection ? dimNames : dimNames.map(() => null)
    },
    dimensionsInfo() {
      return this.dimensionsValues.map((value, dimIndex) => {
        // const name = dimName
        const dimId = this.collection?.dimensionsId
        const filesCount = this.datasetsList
          .filter((d) => d.files.length === this.dimensionsValues.length)
          .map((d) => (d.files && d.files[dimIndex]) || null)
          .filter((el) => el !== null).length
        return { id: dimId, value, filesCount }
      })
    },
    datasetsList() {
      return this.getCollectionDatasetsList(this.collectionId)
    },
    datasetsCount() {
      return this.datasetsList.length || 0
    },
  },
  methods: {
    pluralize,
    ...mapActions('dataloader/collections', ['removeCollectionDatasets']),
  },
}
</script>

<style>
.collection-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0.2rem;
}
</style>
